import axios from "axios";
import { checkSiteStatus } from "../utilities/utilities";
import { getLangValue } from "./config";

let url = process.env.REACT_APP_BACKEND_URL;

export const Client = axios.create({
  baseURL: url,
  withCredentials: true
});

// Interceptor para manejar errores 405
Client.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    
    if (!error.response?.status) {
      const result = await checkSiteStatus(getLangValue("front"));
      if(result === 405)  {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);